import {
  InvoicePaymentType,
  Language,
  InvoicePaymentPeriod,
  InvoiceStatus,
  NotificationStatus,
  WalletOrderType,
  ActivityTemplateStatus
} from '@link/admin/services/const';

export default {
  common: {
    edit: 'Edit',
    search: 'Search',
    keyword: 'Keyword',
    action: 'Operation',
    status: 'Status',
    clickToUpload: 'Upload',
    uploading: 'Uploading',
    copy: 'Copy',
    delete: 'Delete',
    continueConfirm: 'Do you want to continue?',
    confirmDelete: 'Are you sure you want to delete {{name}}?',
    account: 'Account',
    signOut: 'sign out'
  },
  layouts: {
    sidebar: {
      contracts: 'Contract Management',
      suppliers: 'Tour operator Management',
      agents: 'travel agency management',
      finance: 'Payment Management',
      notifications: 'Notification Management',
      dataExport: 'Data Export',
      activities: 'Product List',
      tools: 'Tools',
      opsFreeze: 'OPS Freeze'
    }
  },
  views: {
    opsFreeze: {
      separatorHint:
        'Separate IDs with line breaks, spaces, commas (, ，) or 、',
      register: 'Register',
      bookingIdsInput: 'Enter booking IDs',
      maxBookingCount: 'Max {{max}}',
      exceedMaxCount: 'The maximum number has been exceeded',
      createSuccess: 'Registered successfully',
      freezeOperation: 'Freeze',
      unfreezeOperation: 'Unfreeze',
      reason: 'Remarks',
      reasonPlaceholder: 'Enter the reason (up to {{max}} characters)',
      submitFreeze: 'Freeze',
      submitUnfreeze: 'Unfreeze',
      freezing: 'Freezing',
      unfreezing: 'Unfreezing',
      processingHint:
        'A CSV will be downloaded automatically when processing completes',
      freezeSuccess: 'Freeze completed',
      unfreezeSuccess: 'Unfreeze completed',
      titleWithCount: 'Freeze Records・{{count}}',
      newFreeze: 'New Freeze',
      batchNo: 'No.',
      createdAt: 'Created At',
      status: 'Status',
      targetBookings: 'Target Bookings',
      lastOperation: 'Last Operation',
      bookingCount: '{{count}}',
      statusLabel: {
        frozen: 'Frozen',
        unfrozen: 'Unfrozen',
        notOperated: 'Not Operated'
      },
      action: {
        freeze: 'Freeze',
        unfreeze: 'Unfreeze'
      }
    },
    activities: {
      pageTitle: 'Product List',
      searchTitle: 'Product Search',
      activityId: 'Product ID',
      templateId: 'Template ID',
      activityUrl: 'Product URL',
      title: 'Product Name',
      supplier: 'Supplier',
      supplierId: 'Supplier ID',
      supplierName: 'Supplier Name',
      salesStatus: 'Product Display',
      listDisplay: 'Show in Product List',
      category: 'Category',
      country: 'Country/Region',
      confirmationType: 'Inventory Type',
      inSalePeriod: 'Within Sales Period',
      unspecified: 'Not specified',
      salePeriod: 'Sales Period',
      netPrice: 'Wholesale Price (NET)',
      grossPrice: 'Selling Price (GROSS)',
      unlimited: 'Unlimited',
      downloadCsv: 'Download CSV',
      snapshotHint:
        'Data shown is as of the previous day (updated nightly). Last updated: {{time}}',
      templateStatus: {
        [ActivityTemplateStatus.ActivityTemplateStatusPublished]: 'Published',
        [ActivityTemplateStatus.ActivityTemplateStatusReviewing]:
          'Under Review',
        [ActivityTemplateStatus.ActivityTemplateStatusApproved]: 'Approved',
        [ActivityTemplateStatus.ActivityTemplateStatusDraft]: 'Draft'
      }
    },
    dataExport: {
      period: 'Period',
      dataExport: 'Data Export',
      bookingData: 'Booking Data',
      download: 'Download File',
      monthLabel: '{{year}}/{{month}}',
      downloadHint:
        'Please do not close this page until the download starts automatically.',
      currentMonthHint:
        'For the current month, the data will be delivered to the Slack channel once it is ready. Please wait a moment.',
      slackNotice:
        'The data will be delivered to the Slack channel once it is ready',
      notGenerated: 'Data for the selected period has not been generated yet'
    },
    dashboard: {
      title: 'Dashboard'
    },
    whitelist: {
      title: 'Whitelist',
      add: 'Add to whitelist',
      alertTitle: 'Add travel agency'
    },
    activityPublish: {
      title: 'Product Publish Management',
      alertTitle: 'Product Publish Confirmation'
    },
    suppliersList: {
      title: 'List of tour operators',
      supplierCustomId: 'Tour operator ID',
      originalName: 'Tour operator name',
      englishName: 'Tour operator (EN)',
      country: 'Country/Region',
      action: 'Operation'
    },
    agentsList: {
      title: 'List of travel agencies',
      originalName: 'Travel agency name',
      englishName: 'Travel agency name (EN)',
      paymentType: 'Payment Method',
      country: 'Country/Region'
    },
    orgList: {
      title: 'Group Management',
      searchLabel: 'travel agency'
    },
    agentAccountList: {
      title: 'Account Management',
      otaLabel: 'travel agency',
      otaOrgLabel: 'Group'
    },
    apiKeyList: {
      title: 'api-key',
      otaId: 'Travel agency',
      otaOrgId: 'Organization',
      createTime: 'Creation Date',
      addConfirmTitle: 'Confirm Add API Key',
      deleteConfirmTitle: 'Confirm Delete API Key'
    },
    agentsCharge: {
      title: 'Balance Management'
    },
    financeTransactions: {
      title: 'Settlement Statement',
      transactionStatus: 'Settlement Overview',
      keyword: 'ID Search',
      difference: 'Transaction Type',
      differenceOTA: 'OTA',
      differenceSupplier: 'Supplier',
      dueDate: 'Invoice Issue Date',
      invoiceNumber: 'Billing ID',
      date: 'Billing Period',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: 'Currency Unit',
      amount: 'Total Payment Amount',
      preAmount: 'Pre-adjustment Billing Amount',
      lastAmount: 'Final Total Amount',
      adjustedAmount: 'Adjustment Amount',
      finalAmount: 'Final Total Amount',
      adjust: 'Adjustment',
      showjust: 'Display',
      paid: 'Deposit Completed',
      change: 'Paid',
      invoice: 'Billing Details',
      jaInvoice: 'Payment Notice (Japanese)',
      jaInvoiceDetails: 'Statement (Japanese)',
      enInvoice: 'Payment Notice (English)',
      enInvoiceDetails: 'Statement (English)',
      attachment: 'Attachment',
      changeTitle: 'Has payment been completed?',
      changeTitlePay: 'Has Deposit Been Completed?',
      changeMessage: 'Transaction status will be changed to “Paid”',
      changeMessagePay:
        'Transaction status will be changed to “Deposit Completed”',
      depositTitle: 'Transaction Information',
      depositDate: 'Deposit Date',
      depositAmount: 'Deposit Amount',
      payDate: 'Payment Date',
      payAmount: 'Payment Amount',
      remark: 'Remarks',
      confirmButton: 'Received',
      invoiceList: 'Invoice List',
      payNoticeList: 'Payment Notice List'
    },
    financeCharge: {
      title: 'Balance Management',
      agentId: 'Travel agency ID',
      agentName: 'Travel agency name',
      country: 'Country/Region',
      method: 'Payment Method',
      chargeCycle: 'Settlement Cycle',
      status: 'Pending Verification / Charge History',
      includeDeletedAgents: 'Includes deleted travel agencies',
      bulkDownload: 'Bulk Download',
      downloadTitle: 'Download Balance Records',
      downloadMessage: 'Please select the start time and end time',
      startTime: 'Start Time',
      endTime: 'End Time'
    },
    financeChargeHistory: {
      title: 'Recharge History',
      date: 'Date & Time',
      amount: 'Amount',
      invoice: 'Prepayment Invoice',
      status: 'Status',
      note: 'Remarks',
      code: 'Verification Code',
      change: 'Operation',
      invoiceStatusConfirmed: 'Payment Received',
      changeTitle: 'Payment receipt has been confirmed.',
      changeConfirm:
        'A top-up will be applied to the selected account. Do you want to continue?',
      accountBalance: 'Account Balance',
      accountBuffer: 'Account Buffer',
      deposit: 'Deposit',
      changeAmount: 'Change Amount',
      walletTitle: 'Account Information',
      amountType: 'Deposit Type'
    },
    webHook: {
      title: 'WebHook Settings',
      otaLabel: 'travel agency',
      endpoint: 'End point',
      secretToken: 'Secret token'
    },
    notificationsList: {
      title: 'Manual Notification',
      notification: 'Notification',
      resultCount: 'Search Results: {{count}}',
      notificationTitle: 'Notification Name',
      notificationContent: 'Notification Content',
      sendTime: 'Sent Time',
      sendStatus: 'Sending Status',
      deleteConfirmTitle: 'Are you sure you want to delete this notification?',
      confirmDelete: 'Delete',
      deleteWarning: 'Once deleted, this notification cannot be restored',
      addNew: 'New Notification',
      send: 'Send',
      confirmSend: 'Send',
      sendConfirmTitle: 'Are you sure you want to send this notification?',
      sendSuccess: 'Notification has been sent',
      sendFailed: 'Failed to send notification',
      sendWarning: 'This notification cannot be canceled after sending',
      resend: 'Resend',
      pin: 'Pin',
      unpin: 'Unpin',
      pinConfirmTitle: 'Are you sure you want to pin this notification?',
      unpinConfirmTitle: 'Are you sure you want to unpin this notification?',
      confirmPin: 'Pin',
      confirmUnpin: 'Disable',
      pinSuccess: 'Pinned',
      pinFailed: 'Pin Failed',
      unpinSuccess: 'Unpinned',
      unpinFailed: 'Unpin Failed',
      failedEmailsTitle: 'Failure Details',
      failedEmailTo: 'Recipient',
      failedEmailReason: 'Failure Reason',
      failedEmailsLoadError: 'Failed to retrieve error information',
      noFailedEmails: 'No Failure Data'
    },
    notificationDetail: {
      addTitle: 'New Notification',
      editTitle: 'Edit Notification',
      notificationTitle: 'Notification Name',
      notificationContent: 'Notification Content',
      relatedProducts: 'Related Products',
      productAll: 'Not Related',
      productSpecified: 'Specify Product',
      productIdsHint: 'Enter Product ID (separated by commas)',
      sendTiming: 'Sent Time',
      sendNow: 'Send Immediately',
      scheduled: 'Send at Scheduled Time',
      scheduledTime: 'Booking Date & Time',
      editLanguages: 'Editing Languages',
      editLanguagesRequired: 'Please select at least one editing language',
      langTitle: 'Title',
      langContent: 'Content',
      targetScope: 'Applicable Range',
      targetAll: 'All',
      targetTypeEmail: 'Sent to login email address',
      targetTypeRole: 'Select permission and send',
      targetEmailDomain: 'Target Domain',
      targetEmailDomainAdmin: 'Admin',
      targetEmailDomainOta: 'OTA',
      targetEmailDomainSupplier: 'SUP',
      toEmails: 'Recipient Email Address',
      toEmailsHint: 'Enter your email address (separated by a comma ",")',
      roleOta: 'OTA',
      roleSupplier: 'SUP',
      roleAdmin: 'Admin',
      saveAsDraft: 'Temporary Save',
      send: 'Send',
      savedAsDraft: 'Temporarily Saved',
      saveAsDraftFailed: 'Temporary Save Failed',
      sendSuccess: 'Notification has been sent',
      sendFailed: 'Failed to send notification'
    }
  },
  const: {
    invoicePaymentType: {
      [InvoicePaymentType.PostBankTransfer]: 'Postpaid (Bank Transfer)',
      [InvoicePaymentType.PreLinkpay]: 'Online Payment (Prepaid)',
      [InvoicePaymentType.PostLinkpay]: 'Postpaid (LinkPay)',
      [InvoicePaymentType.PreCharge]: 'Bank Transfer (Prepaid)'
    },
    invoicePaymentPeriod: {
      [InvoicePaymentPeriod.Monthly]: 'Monthly',
      [InvoicePaymentPeriod.Weekly]: 'Weekly',
      [InvoicePaymentPeriod.HalfMonthly]: 'Biweekly'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: 'Pending Deposit',
      [InvoiceStatus.InvoiceStatusConfirmed]: 'Deposit Completed',
      [InvoiceStatus.InvoiceStatusPaid]: 'Under Deposit Confirmation',
      [InvoiceStatus.InvoiceStatusCancelled]: 'Cancelled'
    },
    walletOrderType: {
      [WalletOrderType.TypeBalance]: 'Balance Top-up',
      [WalletOrderType.TypeBuffer]: 'Buffer Charge'
    },
    invoicePayStatus: {
      [InvoiceStatus.InvoiceStatusPending]: 'Preparing Payment',
      [InvoiceStatus.InvoiceStatusConfirmed]: 'Payment Completed',
      [InvoiceStatus.InvoiceStatusPaid]: 'Awaiting Payment Confirmation',
      [InvoiceStatus.InvoiceStatusCancelled]: 'Cancelled'
    },
    notificationStatus: {
      [NotificationStatus.NotificationStatusSent]: 'Sent',
      [NotificationStatus.NotificationStatusTotalFailed]: 'Failed',
      [NotificationStatus.NotificationStatusPartialFailed]:
        'Partial Send Failure',
      [NotificationStatus.NotificationStatusSending]: 'Sending',
      [NotificationStatus.NotificationStatusTempSaved]: 'Temporary Save',
      [NotificationStatus.NotificationStatusScheduled]: 'Pending'
    },
    notificationLanguage: {
      [Language.English]: 'English',
      [Language.Japanese]: 'Japanese',
      [Language.Korean]: 'Korean',
      [Language.SimplifiedChinese]: 'Chinese (Simplified)',
      [Language.TraditionalChinese]: 'Chinese (Traditional)'
    }
  }
};
